import React from 'react'
import { Create, useForm } from '@refinedev/antd'
import { Form } from 'antd'
import { RuleStudio } from './RuleStudio'

export function NotificationRuleCreate() {
  const { formProps, saveButtonProps } = useForm({ resource: 'notification_rules' })

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <RuleStudio />
      </Form>
    </Create>
  )
}
